import { Container } from 'react-bootstrap';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { useIntl } from 'react-intl';
import Config from '../config/Config';
import '../css/DemoModeNavbar.css';

const DemoModeNavbar = () => {
  const intl = useIntl();
  const { companyName, companyUrl, productUrl, backgroundColor, sticky } = Config.demo.banner;

  return (
    <div
      className={`demo-banner${sticky ? ' demo-banner-sticky' : ''}`}
      style={{ backgroundColor }}
    >
      <Container className="demo-banner-inner">
        <span className="demo-banner-company">
          {intl.formatMessage({ id: 'demo_banner_label' })}&nbsp;&nbsp;
          <a
            href={companyUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="demo-banner-link"
          >
            <img src="/favicon.ico" alt="" className="demo-banner-icon" />
            <span className="demo-banner-name">{companyName}</span>
          </a>
        </span>

        {productUrl && (
          <a
            href={productUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="demo-banner-cta"
          >
            {intl.formatMessage({ id: 'demo_banner_explore' })}
            <FaExternalLinkAlt className="demo-banner-ext-icon" />
          </a>
        )}
      </Container>
    </div>
  );
};

export default DemoModeNavbar;
